import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 出入金約定書/刪除
 */
const ProofDocDelete = [
    'POST',
    RouteUrlList.API_ProofDocDelete.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: '',
        errorCode: ''
    }
];
export default ProofDocDelete;
